import { getRequest } from '../services/requestHandler';
import { PutterShaftForSaveDto } from '../models';

export const getPutterShafts = async () => {
  const url = 'putter/getPutterShafts?activeOnly=true&useCache=false';
  const response = await getRequest<PutterShaftForSaveDto>('GetPutterShafts', url);
  return response;
};
